import { render, staticRenderFns } from "./OriginCultural.vue?vue&type=template&id=da93a452&scoped=true&"
import script from "./OriginCultural.vue?vue&type=script&lang=js&"
export * from "./OriginCultural.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da93a452",
  null
  
)

export default component.exports